import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import PageHero from "../components/site/PageHero";
import { PageSection, NumberSteps, CTABand, DisclaimerBox } from "../components/site/ContentBlocks";
import { BUYER_STEPS, TRADING_DISCLAIMER } from "../data/content";

export default function Buyers() {
    return (
        <div className="grain bg-navy-deep" data-testid="buyers-page">
            <Header />
            <main>
                <PageHero
                    seo={{
                        title: "How We Work with Buyers | International Sourcing — Viet Medica Ltd",
                        description:
                            "From a clear product requirement to verified supply connections — how Viet Medica Ltd coordinates sourcing for international buyers.",
                        path: "/buyers",
                    }}
                    crumbs={[{ label: "International Trading", href: "/international-trading" }, { label: "Buyers" }]}
                    eyebrow="International Trading"
                    title="How We Work"
                    titleEm="with Buyers."
                    copy="A clear, detailed requirement is the fastest route to a suitable supply connection. This is how we coordinate the buyer side of every trading and sourcing enquiry."
                />

                <PageSection eyebrow="The Buyer Journey" title="From Requirement to Contract" testid="buyer-steps">
                    <NumberSteps steps={BUYER_STEPS} />
                    <div className="mt-10">
                        <DisclaimerBox text={TRADING_DISCLAIMER} testid="buyers-disclaimer" />
                    </div>
                </PageSection>

                <section className="bg-navy-surface py-20 lg:py-28">
                    <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                        <CTABand
                            title="Submit your product requirement."
                            primary={{ label: "Trading Enquiry", to: "/trading-enquiry", testid: "buyers-enquiry-cta" }}
                            secondary={{ label: "Source from Vietnam", to: "/vietnam-sourcing-agent", testid: "buyers-vietnam-cta" }}
                        />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
